import { Button, Grid, makeStyles, Typography } from '@material-ui/core'
import React, { useState } from 'react'
import { BuscadorUsuarioOspe } from '../parametrizaciones/BuscadorUsuarioOspe';
import SaveIcon from "@material-ui/icons/Save";
import { ValidatorForm } from 'react-material-ui-form-validator';
import { useDispatch } from 'react-redux';
import { putAbmUsuarioPorIdProfesional } from '../../../../actions/turnos/abmUsuarioPorIdProfesional';

const useStyles = makeStyles({
    rootTitulo: {
        paddingLeft: 10,
        marginTop: 10,
        marginBottom: 10,
    },
    titulo: {
        padding: 10,
    },
    div: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center'
    },
    grid: {
        padding: 10,
        marginBottom: 10,
        backgroundColor: 'white',
    },
    button: {
        margin: 5,
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center'
    }
});

export const ModificarUsuarioOspe = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const [ usuarioSel, setUsuarioSel ] = useState();
    const { idEspecialidad, idEfector, idCentroMedico, descripcion, userName, centroMedico, setActualizarUsuario } = props;

    const handleSave = () => {
        dispatch( putAbmUsuarioPorIdProfesional(
            idEfector,
            idCentroMedico,
            idEspecialidad,
            usuarioSel.nroMedicoOspe,
            //descripcion,
            usuarioSel.userName,
            centroMedico,
            setActualizarUsuario,
        ));
        setUsuarioSel();
    }

    return (
        <>
            <Grid item xs={12} md={6} className={classes.grid}>
                <Typography component="h3" variant="h5" className={classes.rootTitulo}>{centroMedico}</Typography>
                <Grid container direction="row" alignItems="center">
                    <ValidatorForm onSubmit={handleSave}>
                            <Grid container xs={12}>
                                <Grid item xs={12} className={classes.div}>
                                    <Typography  
                                        component="h6" 
                                        className={classes.titulo} 
                                    >
                                        ESPECIALIDAD -
                                    </Typography>
                                    <Typography  
                                        component="h6" 
                                    >
                                        {descripcion}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} className={classes.div}>
                                    <Typography  
                                        component="h6" 
                                        className={classes.titulo} 
                                    >
                                        USUARIO OSPEDIC -
                                    </Typography>
                                    <Typography  
                                        component="h6" 
                                    >
                                        {userName}
                                    </Typography>
                                </Grid>
                                <BuscadorUsuarioOspe 
                                    fullWith
                                    setUsuarioSel={setUsuarioSel}
                                />
                                <Grid item xs={12} className={classes.button} >
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        startIcon={<SaveIcon />}
                                        onClick={handleSave}
                                        disabled={!usuarioSel}
                                    >
                                        MODIFICAR
                                    </Button>
                                </Grid>
                            </Grid>
                    </ValidatorForm>
                </Grid>
            </Grid>
        </>
    )
}
